/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminExpertSubscriptionDto } from './AdminExpertSubscriptionDto';
export type AdminExpertListItemResponse = {
    id: string;
    expertId: string;
    fullName: string;
    email?: Record<string, any> | null;
    phoneNumber?: Record<string, any> | null;
    dateOfBirth?: Record<string, any> | null;
    gender?: Record<string, any> | null;
    location?: Record<string, any> | null;
    serviceType?: Record<string, any> | null;
    totalClients: number;
    totalSessions: number;
    /**
     * Admin display label: Active | Hidden | Inactive | Suspended. Active requires verified + availability + (expert pricing OR active package) + accepting bookings.
     */
    accountStatus: string;
    /**
     * Admin display label: Pending upload | Pending review | Requested documents | Rejected | Verified. Derived from experts.verification_status and uploaded documents.
     */
    verificationStatus: string;
    averageRating: number;
    isFastTrackVerification: boolean;
    isSocialMediaSpotlight: boolean;
    dateJoined?: Record<string, any> | null;
    /**
     * Which surface created the account. Accounts predating the web onboarding flow are recorded as app.
     */
    signupPlatform: AdminExpertListItemResponse.signupPlatform;
    /**
     * Whether a mobile login has been recorded (users.last_app_login_at). Stamped on every login carrying an ios/android device_type, so it no longer depends on push notification consent. False means no mobile login on record — for an expert who has not opened the app since this was introduced and had no device row to backfill from, that is still unknown, not proof.
     */
    appInstalled: boolean;
    /**
     * Last recorded mobile login, or null if none is on record.
     */
    appLastUsedAt: string | null;
    /**
     * Platform of the most recent push-registered device. Null when the expert has used the app but never granted notification permission, so appInstalled can be true while this is null.
     */
    appPlatform: AdminExpertListItemResponse.appPlatform | null;
    /**
     * App build on that device.
     */
    appVersion: string | null;
    profileImageUrl?: Record<string, any> | null;
    currentSubscription?: AdminExpertSubscriptionDto | null;
};
export namespace AdminExpertListItemResponse {
    /**
     * Which surface created the account. Accounts predating the web onboarding flow are recorded as app.
     */
    export enum signupPlatform {
        APP = 'app',
        WEB = 'web',
    }
    /**
     * Platform of the most recent push-registered device. Null when the expert has used the app but never granted notification permission, so appInstalled can be true while this is null.
     */
    export enum appPlatform {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
}

